import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./pages/tabs/tabs.module').then(m => m.TabsPageModule)
  },
  {
    path: 'onboarding',
    loadChildren: () => import('./pages/onboarding/onboarding.module').then(m => m.OnboardingPageModule)
  },
  {
    path: 'components',
    loadChildren: () => import('./pages/components/components.module').then( m => m.ComponentsPageModule)
  },
  {
    path: 'select-list',
    loadChildren: () => import('./modal/select-list/select-list.module').then( m => m.SelectListPageModule)
  },
  {
    path: 'profissional-filter',
    loadChildren: () => import('./modal/profissional-filter/profissional-filter.module').then( m => m.ProfissionalFilterPageModule)
  },
  {
    path: 'formacao',
    loadChildren: () => import('./modal/formacao/formacao.module').then( m => m.FormacaoPageModule)
  },
  {
    path: 'favoritos',
    loadChildren: () => import('./pages/favoritos/favoritos.module').then( m => m.FavoritosPageModule)
  },
  {
    path: 'perfil-usuario/:id',
    loadChildren: () => import('./pages/perfil-usuario/perfil-usuario.module').then( m => m.PerfilUsuarioPageModule)
  },
  {
    path: 'perfil-usuario-editar',
    loadChildren: () => import('./pages/perfil-usuario-editar/perfil-usuario-editar.module').then( m => m.PerfilUsuarioEditarPageModule)
  },
  {
    path: 'perfil-usuario-editar/:id',
    loadChildren: () => import('./pages/perfil-usuario-editar/perfil-usuario-editar.module').then( m => m.PerfilUsuarioEditarPageModule)
  },
  {
    path: 'dados-academicos/:id',
    loadChildren: () => import('./pages/dados-academicos/dados-academicos.module').then( m => m.DadosAcademicosPageModule)
  },
  {
    path: 'contatos/:id',
    loadChildren: () => import('./pages/contatos/contatos.module').then( m => m.ContatosPageModule)
  },
  {
    path: 'telefone',
    loadChildren: () => import('./modal/telefone/telefone.module').then( m => m.TelefonePageModule)
  },
  {
    path: 'email',
    loadChildren: () => import('./modal/email/email.module').then( m => m.EmailPageModule)
  },
  {
    path: 'linkedin',
    loadChildren: () => import('./modal/linkedin/linkedin.module').then( m => m.LinkedinPageModule)
  },
  {
    path: 'idioma',
    loadChildren: () => import('./modal/idioma/idioma.module').then( m => m.IdiomaPageModule)
  },
  {
    path: 'projeto',
    loadChildren: () => import('./modal/projeto/projeto.module').then( m => m.ProjetoPageModule)
  },
  {
    path: 'curriculo',
    loadChildren: () => import('./modal/curriculo/curriculo.module').then( m => m.CurriculoPageModule)
  },
  {
    path: 'termo-aceite',
    loadChildren: () => import('./modal/termo-aceite/termo-aceite.module').then( m => m.TermoAceitePageModule)
  },
  {
    path: 'questionario',
    loadChildren: () => import('./pages/questionario/questionario.module').then( m => m.QuestionarioPageModule)
  },
  {
    path: 'questionario/:slide',
    loadChildren: () => import('./pages/questionario/questionario.module').then( m => m.QuestionarioPageModule)
  },
];
@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
